import { CreateAttachmentUploadOptionsMutation } from 'scripts/constants'
import { fetch, getStorageKey, Storage } from 'scripts/utils'

type Param = {
  urlToken: string
  fieldCode: string
  fileName: string
}
export default function CreateAttachmentUploadOptions({ urlToken, fieldCode, fileName }: Param) {
  const variables = {
    publishedEntryId: Storage.getItem(getStorageKey('publishedEntryId', urlToken)),
    fieldCode,
    fileName,
  }

  return new Promise((resolve, reject) => {
    fetch({
      input: {
        query: CreateAttachmentUploadOptionsMutation,
        variables,
      },
      successCallback: ({ data }) => {
        resolve(data)
      },
      errorCallback: (data) => {
        return reject(data)
      },
    })
  })
}
